import {
  CampaignConditionNewFormat,
  TransactionItemFilterType,
} from "types/campaigns";
import { BadgeReadOnlyParam } from "./ParamsReadOnly/BadgeReadOnlyParam";
import { WalletReadOnlyParam } from "./ParamsReadOnly/WalletReadOnlyParam";

interface Props {
  conditionObject: TransactionItemFilterType | CampaignConditionNewFormat;
}

export const ParamsReadOnly = ({ conditionObject }: Props) => {
  const { field } = conditionObject.value;

  switch (field) {
    case "transaction.items.qty":
    case "transaction.items.grossValue":
      return null;
    case "customer.wallets.activeUnits":
    case "customer.wallets.expiredUnits":
    case "customer.wallets.blockedUnits":
    case "customer.wallets.lockedUnits":
    case "customer.wallets.earnedUnits":
    case "customer.wallets.spentUnits":
    case "referrer.wallets.activeUnits":
    case "referrer.wallets.expiredUnits":
    case "referrer.wallets.blockedUnits":
    case "referrer.wallets.lockedUnits":
    case "referrer.wallets.earnedUnits":
    case "referrer.wallets.spentUnits":
      return <WalletReadOnlyParam conditionObject={conditionObject} />;
    case "customer.badges":
    case "referrer.badges":
      return <BadgeReadOnlyParam conditionObject={conditionObject} />;
    default:
      return null;
  }
};
